// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610140505/js/" + chunkId + "." + {"44":"49372b5c","225":"d275a534","481":"d22dd5af","486":"ba1cfd34","770":"85187d7e"}[chunkId] + ".0.2918817927486226.chunk.js";
};